import React from 'react'
import { IndexLink, Link } from 'react-router'

import PropTypes from 'prop-types'

import { SVGIcon } from '..'

/**
 * Constructs a link element with an href to a path, and nests an svg element along
 * with a span enclosing the provided title of the navigation route to display.
 *
 * @param {{
*   id: string,
*   ariaLabel,
*   pathname: string,
*   query: object,
*   iconSrc: string,
*   onSvgLoad:(string) => HTMLOrSVGImageElement,
*   svgKey: string,
*   title: string,
*   homeLink?: boolean,
*   linkClassName?: string,
*   onClick: () => void,
*   children?: React.Node
* }}
* @return {React.ReactNode}
*/
const DeviceCategoryLink = ({
  id,
  ariaLabel,
  pathname,
  query,
  iconSrc,
  onSvgLoad,
  svgKey,
  title,
  homeLink,
  linkClassName,
  onClick,
  children
}) => {
  const RouterLink = homeLink ? IndexLink : Link
  return (
    <RouterLink
      id={id}
      aria-label={ariaLabel}
      to={{ pathname, query }}
      activeClassName="active-nav"
      className={linkClassName || ''}
      onClick={onClick}
    >
      <SVGIcon src={iconSrc} onLoad={() => onSvgLoad(svgKey)} />
      <span>{title}</span>
      {children}
    </RouterLink>
  )
}

DeviceCategoryLink.propTypes = {
  id: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  iconSrc: PropTypes.string.isRequired,
  onSvgLoad: PropTypes.func.isRequired,
  svgKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  homeLink: PropTypes.bool,
  linkClassName: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node
}

export default DeviceCategoryLink



// WEBPACK FOOTER //
// ./src/components/SubHeader/DeviceCategoryLink.js